import { render, staticRenderFns } from "./roleTable.vue?vue&type=template&id=4fd140b5&scoped=true&"
import script from "./roleTable.vue?vue&type=script&lang=js&"
export * from "./roleTable.vue?vue&type=script&lang=js&"
import style0 from "./roleTable.vue?vue&type=style&index=0&id=4fd140b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd140b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd140b5')) {
      api.createRecord('4fd140b5', component.options)
    } else {
      api.reload('4fd140b5', component.options)
    }
    module.hot.accept("./roleTable.vue?vue&type=template&id=4fd140b5&scoped=true&", function () {
      api.rerender('4fd140b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/userManage/detail/roleTable.vue"
export default component.exports